module.exports = __webpack_public_path__ + "img/search_icon.c9bb336b.svg";